import React from 'react';
import { Icon } from '@fluentui/react';
import styles from './MobileSidebarToggle.module.css';

interface MobileSidebarToggleProps {
    onToggle: () => void;
    savedCarsCount?: number;
    className?: string;
}

const MobileSidebarToggle: React.FC<MobileSidebarToggleProps> = ({
    onToggle,
    savedCarsCount = 0,
    className = ''
}) => {
    return (
        <button
            className={`${styles.toggleButton} ${className}`}
            onClick={onToggle}
            type="button"
            aria-label="Open menu"
        >
            <Icon iconName="GlobalNavButton" className={styles.toggleIcon} />
            {savedCarsCount > 0 && (
                <span className={styles.badge} aria-label={`${savedCarsCount} saved cars`}>
                    {savedCarsCount > 9 ? '9+' : savedCarsCount}
                </span>
            )}
        </button>
    );
};

export default MobileSidebarToggle;